module.exports = __webpack_public_path__ + "components/location-nav/static/icon-caret-down--filled-27333d129b35c863646b328974c87c7c.svg";